import { FEATURES } from '../constants/features';
export const hasFeature = (enabledFeatures, feature) => enabledFeatures && enabledFeatures.length > 0 ? enabledFeatures.includes(feature) : true;
export const hasCommentingFeature = enabledFeatures => {
  if (!enabledFeatures) {
    return false;
  }
  return enabledFeatures.includes(FEATURES.COMMENTS) || enabledFeatures.includes(FEATURES.DEEP_COMMENTING);
};
export const hasDeepCommentingFeature = enabledFeatures => {
  if (!enabledFeatures) {
    return false;
  }
  return enabledFeatures.includes(FEATURES.DEEP_COMMENTING);
};